import { Button, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { UpsaleSteps } from 'src/upsale/containers/AppUpsale'
import { CardHistoryGrid } from './components/CardHistoryGrid'

type IntroProps = {
  title: string
  description: string
  onNext: (step: UpsaleSteps) => void
}

export const Intro = (props: IntroProps) => {
  const { title, description, onNext } = props
  const introChild = <CardHistoryGrid />

  return (
    <Flex flexDirection="column" width="100%" height="100%" inset="x2">
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignContent="center"
        width="100%"
      >
        {introChild}
      </Flex>
      <Text
        outset={{ bottom: 'x5', horizontal: 'x2' }}
        type="subtitle"
        weight="bold"
        whiteSpace="normal"
        alignment="center"
        content={title}
      />
      <Text
        outset={{ bottom: 'x5', horizontal: 'x2' }}
        type="body"
        color="primaryBody"
        alignment="center"
        content={description}
        whiteSpace="normal"
      />
      <Flex
        width="100%"
        height="1fr"
        justifyContent="center"
        alignItems="center"
        columnGap={'x2'}
        outset={{ bottom: ' 34px' }}
      >
        <Button
          title="Cancel"
          backgroundColorOverride="white"
          textColorOverride="#D1D5DB"
        />
        <Button
          title="Continue"
          backgroundColorOverride="#404040"
          onClick={() => {
            onNext('Selecting')
          }}
        />
      </Flex>
    </Flex>
  )
}
